<template>
    <div class="datePicker">
        <div v-if="showLabel" class="label">{{ labelName }}</div>
        <div class="content" :style="showLabel ?? { width: '100%' }">
            <el-date-picker v-model="dateValue" type="date" format="yyyy-MM-dd" value-format="timestamp" range-separator="至"
                :size="size" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
                @change="change($event)" :clearable="clearable">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
export default {
    name: "DatePicker",
    props: {
        showLabel: {
            type: Boolean,
            default: true
        },
        labelName: {
            type: String,
            default: '选择时间'
        },
        size: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dateValue: this.$moment().startOf('day').format('x'),
            //日期范围限制
            pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() > this.$moment().endOf('day').format('x');
                },
            },
        }
    },
    methods: {
        change(value) {
            this.$emit('dateChange', value);
        }
    },
    mounted() {
        // console.log(this.$moment().startOf('day').format('x'))
    },
}
</script> 

<style lang="scss" scoped>
.datePicker {
    @include setFlexBetween;

    .label {
        width: 60px;
    }

    .content {
        width: calc(100% - 70px);

        &>div {
            width: 100%;
        }
    }
}
</style>